import { CircularProgress, Container, styled } from '@mui/material';

export const Loading = () => {
  return (
    <StyledContainer>
      <CircularProgress aria-label="Loading…" />
    </StyledContainer>
  );
};

const StyledContainer = styled(Container)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100%',
});
